import type { DecoratedDesignResponse } from '@customink/project-service-react-components';

/**
 * Returns color count of the side with the most colors
 */
export const biggestColorCount = (design?: DecoratedDesignResponse): number => {
  return Object.values(design?.colorCounts || {}).reduce(
    (acc, count) => Math.max(acc, count),
    0,
  );
};
